"use client"

import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"
import { ChartPeriodSelectorReatom } from "./chart-period-selector.reatom"
import { FloorPriceChartMoleculeReatom } from "./floor-price-chart-molecule.reatom"
import { FloorPriceChartReatom } from "./floor-price-chart.reatom"

export const FloorPriceChartSectionReatom = reatomComponent(() => {
  const { openedAtom } = useMolecule(FloorPriceChartMoleculeReatom)
  const opened = openedAtom()

  if (!opened) return null

  return (
    <div className="px-4 pb-4 md:px-8 md:pb-6">
      <div className="flex flex-col gap-2 border-b-[2px] pt-3 pb-6">
        <div className="flex aspect-[5/1] w-full cursor-pointer flex-col items-center justify-center">
          <FloorPriceChartReatom />
        </div>
        <ChartPeriodSelectorReatom />
      </div>
    </div>
  )
})
